{
  "ui": {
    "feedback": "Comentários",
    "credits": "Créditos",
    "currentMaintainer": "Manutenção atual",
    "maintainerPeriod": "Desde 2026",
    "originalTeam": "Equipa original",
    "creditsCampaigns": "Selva e Natal",
    "moreSettings": "Mais definições",
    "chooseLanguage": "Escolhe o teu idioma",
    "notebookTools": "Ferramentas do caderno",
    "visualGuide": "Guia ilustrado",
    "templeSoon": "Em breve",
    "playAdventure": "Jogar",
    "story": "A história",
    "loadingAdventure": "A preparar a aventura…",
    "storyOpening": "Uma visita de estudo à selva. Marco e Sophia exploram com os amigos. Um pássaro colorido chama a atenção de Marco, que o segue por entre as árvores. De repente, está sozinho. Ajuda os exploradores a encontrar o caminho!",
    "storyEnding": "Marco e Sophia chegam juntos ao templo perdido. Um rosto misterioso guarda a entrada. Uma nova aventura espera por eles!",
    "blockCategories": "Separadores do caderno",
    "actions": "Ações",
    "loops": "Ciclos",
    "conditions": "Condições",
    "title": "Run Marco! — Uma aventura no teu caderno",
    "home": "Início do Run Marco",
    "map": "Mapa da aventura",
    "worlds": "Escolhe uma aventura",
    "notebook": "O meu caderno",
    "notebookToggle": "Abrir ou fechar o caderno",
    "notebookOpen": "Abrir o caderno",
    "notebookClose": "Ver o caminho",
    "page": "Página {number}",
    "level": "Trilho {number}",
    "run": "Vamos!",
    "stop": "Parar",
    "step": "Um passo",
    "stepTitle": "Executar uma instrução",
    "reset": "Voltar ao início",
    "add": "Adicionar",
    "addLabel": "Escolhe um bloco para adicionar",
    "addHint": "Liga os blocos e carrega em Jogar.",
    "undo": "Anular",
    "clear": "Página nova",
    "hint": "Uma pequena pista",
    "help": "Como jogar",
    "settings": "Definições",
    "language": "Idioma do jogo",
    "blockLanguage": "Idioma dos blocos",
    "blockLanguageNote": "Podes escolher outro idioma para os blocos.",
    "musicOn": "Ativar o som",
    "musicOff": "Desativar o som",
    "sound": "Música e efeitos sonoros",
    "speed": "Velocidade da aventura",
    "chooseExplorer": "Escolhe o teu explorador",
    "explorer": "Explorador",
    "marco": "Marco",
    "sophia": "Sophia",
    "close": "Fechar",
    "done": "Vamos explorar!",
    "loading": "À procura do caminho…",
    "loadError": "Não foi possível carregar a aventura. Atualiza a página para tentar novamente.",
    "imageError": "Não foi possível carregar algumas imagens. Atualiza a página.",
    "gemGoal": "Encontra a gema",
    "goal": "Encontra a estrela dourada",
    "cover": "Ilumina cada casa uma única vez",
    "lit": "{count} / {total} casas iluminadas",
    "explored": "{count} / {total} trilhos explorados",
    "facing": "A olhar para {direction} {arrow}",
    "boardLabel": "{name} em {level}, a olhar para {direction}. {steps}. {objective}.",
    "up": "cima",
    "down": "baixo",
    "left": "a esquerda",
    "right": "a direita",
    "steps_one": "{count} passo",
    "steps_other": "{count} passos",
    "blocks_one": "{count} bloco",
    "blocks_other": "{count} blocos",
    "stars_one": "{count} estrela",
    "stars_other": "{count} estrelas",
    "place": "Adicionar blocos",
    "atEnd": "No fim",
    "insideRepeat": "Dentro de repetir {number}",
    "insideIf": "Dentro de se {number}",
    "insideElse": "Dentro de senão {number}",
    "readyFirst": "Um pequeno passo. Adiciona um bloco para avançar e vamos!",
    "ready": "Para onde vamos? Prepara um plano no caderno.",
    "back": "De volta ao início. Os teus blocos estão prontos para outra tentativa.",
    "empty": "Primeiro, adiciona um bloco ao caderno.",
    "win": "Encontraste o caminho!",
    "winCover": "Iluminaste o caminho!",
    "winDetails": "{steps} · {blocks}",
    "brilliant": "Que aventura!",
    "simpler": "Consegues usar menos blocos?",
    "complete": "Trilho concluído! As tuas melhores estrelas estão guardadas.",
    "next": "Próximo trilho",
    "allWorlds": "Mais aventuras",
    "replay": "Jogar novamente",
    "shortGoal": "Quase! Adiciona mais alguns blocos para chegar à estrela.",
    "shortGem": "Quase! Adiciona mais alguns blocos para chegar à gema.",
    "shortCover": "Algumas casas ainda estão escuras. Como chegamos até elas?",
    "checking": "A observar o caminho…",
    "paused": "Em pausa. Jogar recomeça desde o início.",
    "going": "Lá vamos nós!",
    "stepped": "Mais um passo. Carrega em Um passo ou Jogar para continuar.",
    "clueCover": "Começa numa borda e percorre toda a figura. Um salto passa por cima de uma casa sem a iluminar.",
    "clueCondition": "Olha para o caminho à frente. Uma condição ajuda o explorador a escolher o que fazer.",
    "clueRepeat": "Que passos se repetem? Coloca esse padrão dentro de um ciclo.",
    "clueForward": "Avançar segue a direção do explorador. Conta as casas até à estrela.",
    "clueGem": "Avançar segue a direção do explorador. Conta as casas até à gema.",
    "clueTurn": "Virar muda a direção sem avançar. Segue o caminho com o dedo.",
    "mapNote": "Escolhe um trilho. As tuas melhores estrelas ficam guardadas.",
    "mapLevel": "Trilho {number}: {name}. {stars}.",
    "locked": "Conclui o trilho anterior para desbloquear este.",
    "soundBlocked": "Toca no botão do som para ouvir a aventura.",
    "clearTitle": "Passar para uma página nova?",
    "clearNote": "Os blocos deste trilho serão apagados. Anular permite recuperá-los.",
    "keep": "Manter os meus blocos",
    "clearConfirm": "Apagar blocos",
    "fresh": "Uma página nova. Aonde nos levará o teu próximo plano?",
    "localProgress": "O teu progresso é guardado neste dispositivo.",
    "helpBuild": "Prepara um plano",
    "helpBuildText": "Arrasta blocos para o caderno e liga-os, ou toca num bloco para o adicionar. Escolhe «Dentro de repetir» para inserir passos num ciclo.",
    "helpTurn": "Segue o teu explorador",
    "helpTurnText": "Avançar segue o olhar do explorador. Esquerda e direita viram sem avançar. Um salto percorre duas casas.",
    "helpTry": "Experimenta, observa e tenta outra vez",
    "helpTryText": "Carrega em Jogar para testar o plano ou Um passo para uma instrução. A seta curva volta ao início e mantém os blocos.",
    "helpWorlds": "Cada aventura tem um objetivo",
    "helpWorldsText": "Na Selva, encontra a gema. No Natal, ilumina cada casa livre uma vez. No Templo e no Egeu, conclui as reparações e os objetivos visíveis e chega à saída.",
    "noTrail": "Não há caminho aí! Experimenta virar antes de avançar.",
    "broken": "Essa ponte está partida. Consegues saltar por cima?",
    "blocked": "Algo bloqueia o caminho. Experimenta um salto ou outro percurso.",
    "alreadyLit": "Essa casa já está iluminada. Visita cada casa uma única vez.",
    "loopError": "Este plano repete-se sem parar. Experimenta mudar o ciclo.",
    "repeatError": "Escolhe um número de repetições entre 1 e 99.",
    "unsupported": "Remove o bloco não suportado e tenta novamente.",
    "connect": "Liga os blocos numa só sequência e carrega em Jogar.",
    "path": "caminho",
    "steps_many": "{count} passos",
    "blocks_many": "{count} blocos",
    "stars_many": "{count} estrelas",
    "backpack": "Mochila",
    "templeGems": "Gemas do templo",
    "gemsCollected": "Gemas: {count} / {total}",
    "gemsReady": "Recolheste todas as gemas!",
    "aegeanTitle": "Os mistérios do Egeu",
    "harbour": "Porto",
    "aegeanDescription": "Explora o porto: repara estações, reutiliza rotinas e envia um número com cada tarefa.",
    "templeBetaNote": "Beta · Estamos a rever os desafios e as lições",
    "aegeanBetaNote": "Beta · Os primeiros 3 níveis do porto",
    "seasonal": "Aventura sazonal",
    "choosePreview": "Escolhe um nível de pré-visualização",
    "repairs": "Reparações",
    "reachExit": "Chega à saída",
    "taskRequirements": "Objetivos da missão",
    "lessonGuided": "Prática guiada · completa o programa fornecido",
    "lessonRepair": "Depuração · corrige o programa fornecido",
    "lessonChallenge": "Desafio · cria o teu próprio programa",
    "acc_define_parameter": "Rotina",
    "acc_call_argument": "Chamar rotina",
    "acc_repeat_parameter": "Repetir com a entrada",
    "parameter": "parâmetro",
    "argument": "enviar",
    "callInput": "Entrada desta chamada",
    "inputWaiting": "Executa o programa ou avança uma instrução de cada vez para veres a próxima entrada.",
    "argumentMismatch": "Uma rotina com parâmetro precisa de uma chamada com um número. Sem parâmetro, usa uma chamada normal.",
    "unsetParameter": "Usa o parâmetro apenas dentro da rotina que o recebe. Os parâmetros são separados da memória partilhada.",
    "memoryObjective": "Verifica o registo de reparações e os objetivos da saída. Qualquer programa que os cumpra é aceite.",
    "gate": "A passagem está bloqueada. Verifica as reparações por terminar.",
    "noPickup": "Coloca-te sobre a ferramenta antes de a apanhares.",
    "creditLead": "Liderança da equipa e desenvolvimento de software",
    "creditArt": "Ilustração e cenários",
    "creditAnimation": "Animação",
    "creditUX": "Design de interface e experiência de utilização",
    "creditDesign": "Design do jogo",
    "creditStory": "Escrita da história",
    "creditAudio": "Música e engenharia de som",
    "lightLamp": "Acender lamparina",
    "oilLamp": "Lamparina",
    "dustyStation": "estação com pó",
    "betaLabel": "Beta",
    "noLamp": "Coloca-te numa lâmpada apagada antes de a acender.",
    "collected": "Ferramenta recolhida · pronta a usar",
    "dustyPrompt": "Coloca-te numa estação com pó antes de usar o pincel.",
    "lampMissing": "Recolhe primeiro a lamparina. Vê na mochila.",
    "recursiveRoutine": "Esta rotina chama-se a si própria. Usa outra rotina; as chamadas recursivas ainda não estão disponíveis."
  },
  "content": {
    "jungle.title": "Expedição na selva",
    "jungle.description": "Segue o trilho até ao templo perdido.",
    "jungle-1": "Primeiros passos",
    "jungle-2": "Um pouco mais longe",
    "jungle-3": "Ao virar da esquina",
    "jungle-4": "Muda de direção",
    "jungle-5": "Segue o trilho",
    "jungle-6": "Um novo percurso",
    "jungle-7": "Novos caminhos",
    "jungle-8": "Cruzamento na selva",
    "jungle-9": "Encontra o caminho",
    "jungle-10": "Pensa à frente",
    "jungle-11": "O trilho longo",
    "jungle-12": "Um percurso sinuoso",
    "jungle-13": "Um salto corajoso",
    "jungle-14": "Surgem padrões",
    "jungle-15": "Repete o ritmo",
    "jungle-16": "Escolhe um caminho",
    "jungle-17": "Olha antes de saltar",
    "jungle-18": "Lê o trilho",
    "jungle-19": "Um desvio esperto",
    "jungle-20": "Sob as copas",
    "jungle-21": "Construtor de pontes",
    "jungle-22": "Além do rio",
    "jungle-23": "Explora as ruínas",
    "jungle-24": "Pedra e madeira",
    "jungle-25": "Um salto maior",
    "jungle-26": "Segue as pistas",
    "jungle-27": "Mais alto",
    "jungle-28": "Continua a explorar",
    "jungle-29": "Caminhos sinuosos",
    "jungle-30": "O jardim secreto",
    "jungle-31": "Padrões escondidos",
    "jungle-32": "Caminhos antigos",
    "jungle-33": "As últimas curvas",
    "jungle-34": "Rumo ao templo",
    "jungle-35": "Quase a chegar",
    "jungle-36": "O templo perdido",
    "winter.title": "Trilho de inverno",
    "winter.description": "Deixa uma luz em cada pegada.",
    "winter-1": "Passos na neve",
    "winter-2": "Outra direção",
    "winter-3": "Cantos gelados",
    "winter-4": "O caminho mais longo",
    "winter-5": "Floco de neve",
    "winter-6": "Ciclos de inverno",
    "winter-7": "Explorador do gelo",
    "winter-8": "Voltas e curvas",
    "winter-9": "Lógica gelada",
    "winter-10": "Descobridor de padrões",
    "winter-11": "Mestre do trilho",
    "winter-12": "Maravilha de inverno",
    "temple.title": "O templo perdido",
    "temple.description": "Quarenta salas ligadas: restaura um instrumento celeste com ferramentas, memória e as tuas rotinas."
  },
  "blockly": {
    "ARIA_LABEL_TRASH_EMPTY": "Caixote do lixo vazio",
    "OPEN_TRASH": "Abrir caixote do lixo",
    "BLOCK_LABEL_BEGIN_STACK": "Início da pilha",
    "WORKSPACE_LABEL_1_STACK": "1 pilha de blocos",
    "WORKSPACE_LABEL_MANY_STACKS": "%1 pilhas de blocos",
    "ARIA_TYPE_FIELD_NUMBER": "número",
    "ARIA_TYPE_FIELD_DROPDOWN": "lista pendente",
    "ARIA_TYPE_FIELD_IMAGE": "imagem",
    "WORKSPACE_LABEL_PLAIN": "O meu caderno",
    "FIELD_LABEL_EDIT_PREFIX": "Editar %1",
    "BLOCK_LABEL_HAS_INPUT": "tem uma entrada",
    "BLOCK_LABEL_HAS_INPUTS": "tem entradas",
    "BLOCK_LABEL_HAS_BRANCHES": "tem %1 ramos",
    "FIELD_LABEL_OPTION_INDEX": "Opção %1",
    "INPUT_LABEL_EMPTY": "Vazio",
    "BLOCK_LABEL_DISABLED": "desativado",
    "BLOCK_LABEL_COLLAPSED": "recolhido",
    "BLOCK_LABEL_BEGIN_PREFIX": "Início: %1",
    "INPUT_LABEL_END_STATEMENT": "Fim: %1",
    "ARIA_TYPE_FIELD_TEXT_INPUT": "texto",
    "ARIA_TYPE_FIELD_INPUT": "entrada",
    "ARIA_TYPE_FIELD_TEXT_INPUT_ARGUMENT": "nome da entrada",
    "ARIA_TYPE_FIELD_TEXT_INPUT_PROCEDURE": "nome da rotina"
  }
}
